import t from "@zh-or/lib/index";

export default function() {
    //sessionStorage.setItem('token', '');
    t.showWait('登录中...');
    setTimeout(_ => {
        let jumpHost = encodeURIComponent(location.origin + location.pathname);
        //location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb5df01aee1d7fe3b&redirect_uri=${jumpHost}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        //location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8757659f57c95ad4&redirect_uri=${jumpHost}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8757659f57c95ad4&redirect_uri=${jumpHost}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }, 1000);
}
